<script>

import config from '../../common/genericPanelConf';
import GenericDataTable from '../../components/generic/GenericDataTable.vue';

export default {
    components: {
        GenericDataTable
    },
    data(){
        return{
            configuration: null,
            code: null
        }
    },
    created(){
        this.configuration = config.getConfiguration('VesselProtocolAlertDetails');
        if(this.configuration){
            this.$store.dispatch('security/setNavbarTitle', 'VesselProtocolAlerts.page_title');
        }
    },
    mounted(){
        if(this.$route.query.code){
          this.code = this.$route.query.code;
          this.loadData();
        }
    },
    methods: {
        loadData(){
          this.$refs.grid.filterFromView({alertType: this.code}, true);
        }
    },
    computed: {
        conf(){
            return config;
        }
    }
}
</script>



<template>
    <div class="" style="height: 80vh;">
        <GenericDataTable :configuration="configuration" :category="'vessel-protocol-alerts'" :name="'vessel-protocol-alerts-details'" ref="grid" />
    </div>
</template>